import Position from './Position';

export enum PlaygroundState {
	Active,
	Win,
	Loss,
}

export class Playground {
	positions: Position[][] = [];
	state: PlaygroundState = PlaygroundState.Active;
	startTime = Date.now();
	private minesAdded = false;

	constructor(readonly height: number, readonly width: number, readonly minesCount: number) {
		this.createPositions();
	}

	private preparePlayground() {
		this.addMines();
		this.addCountMinesAroundPosition();
	}

	private createPositions() {
		for (let y = 0; y < this.height; y++) {
			this.positions.push([]);
			for (let x = 0; x < this.width; x++) {
				this.positions[y].push(new Position(false));
			}
		}
	}

	private addMines() {
		let added = 0;
		while (added < this.minesCount) {
			const y = Math.floor(Math.random() * this.height);
			const x = Math.floor(Math.random() * this.width);
			if (!this.positions[y][x].mine && !this.positions[y][x].uncover) {
				this.positions[y][x] = new Position(true);
				added++;
			}
		}
	}

	private addCountMinesAroundPosition() {
		for (let y = 0; y < this.height; y++) {
			for (let x = 0; x < this.width; x++) {
				this.positions[y][x].minesAround = this.countMinesAroundPosition(y, x);
			}
		}
	}

	private countMinesAroundPosition(y: number, x: number) {
		let count = 0;
		for (let shiftY = y - 1; shiftY <= y + 1; shiftY++) {
			for (let shiftX = x - 1; shiftX <= x + 1; shiftX++) {
				if (this.positions[shiftY] && this.positions[shiftY][shiftX] && this.positions[shiftY][shiftX].mine && (x !== shiftX || y !== shiftY)) {
					count++;
				}
			}
		}
		return count;
	}

	uncoverPosition(y: number, x: number) {
		if (y < 0 || y >= this.height) return;
		if (x < 0 || x >= this.width) return;
		const position = this.positions[y][x];
		if (position.uncover) return;
		if (position.marked) return;
		if (position.mine) {
			position.exploded = true;
			this.uncoverField();
			return;
		}
		position.uncover = true;
		if (!this.minesAdded) {
			this.preparePlayground();
			this.minesAdded = true;
		}
		const uncoverAround = (y: number, x: number) => {
			if (this.positions[y] && this.positions[y][x] && !this.positions[y][x].mine && !this.positions[y][x].marked) {
				if (this.positions[y][x].minesAround === 0) {
					this.uncoverPosition(y, x);
				} else {
					this.positions[y][x].uncover = true;
				}
			}
		};
		// Uncover around (shape +)
		if (position.minesAround === 0) {
			uncoverAround(y, x - 1);
			uncoverAround(y, x + 1);
			uncoverAround(y - 1, x);
			uncoverAround(y + 1, x);
		}
	}

	checkEnd() {
		let uncover = 0;
		for (let y = 0; y < this.height; y++) {
			for (let x = 0; x < this.width; x++) {
				const position = this.positions[y][x];
				if (position.exploded) {
					this.state = PlaygroundState.Loss;
					return;
				}
				if (position.uncover) uncover++;
			}
		}
		if (uncover + this.minesCount === this.width * this.height) {
			this.state = PlaygroundState.Win;
		}
	}

	markPositionToggle(y: number, x: number) {
		const position = this.positions[y][x];
		if (position.uncover) return;
		position.marked = !position.marked;
	}

	private uncoverField() {
		for (let y = 0; y < this.height; y++) {
			for (let x = 0; x < this.width; x++) {
				const position = this.positions[y][x];
				position.uncover = true;
				if (position.marked && !position.mine) {
					position.markedWrong = true;
				}
			}
		}
	}
}
